import { render } from "./CoLink.vue?vue&type=template&id=34cbf078"
import script from "./CoLink.vue?vue&type=script&lang=js"
export * from "./CoLink.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__